// extracted by mini-css-extract-plugin
export var quoteCarousel = "QuoteCarousel-module--quoteCarousel--1141b";
export var quoteCarousel__author = "QuoteCarousel-module--quoteCarousel__author--7f59a";
export var quoteCarousel__body = "QuoteCarousel-module--quoteCarousel__body--13e7f";
export var quoteCarousel__header = "QuoteCarousel-module--quoteCarousel__header--c62b4";
export var quoteCarousel__image = "QuoteCarousel-module--quoteCarousel__image--75566";
export var quoteCarousel__inner = "QuoteCarousel-module--quoteCarousel__inner--0149b";
export var quoteCarousel__navIconBtn = "QuoteCarousel-module--quoteCarousel__navIconBtn--13981";
export var quoteCarousel__quote = "QuoteCarousel-module--quoteCarousel__quote--854ff";
export var quoteCarousel__quote___bg = "QuoteCarousel-module--quoteCarousel__quote___bg--60d19";
export var quoteCarousel__video = "QuoteCarousel-module--quoteCarousel__video--ff29b";